import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { ptlEnvs } from "@/tra/tancis/ptli/comn";
import { api } from "@/comn";
import { comnUtils } from "@/comn/utils";

/*
 * Linking Customs Roles
 * !== 세관 역할 연결 화면 ==!
 */

/*
 * @ BASE
 * @ 서비스에서 사용하는 기본 정보 세팅
 * @ path : 화면들의 기본 웹 경로
 * @ api : 사용하는 api 의 기본 주소
 * @ api 주소가 여러개일 경우 _ 로구분하여 의미에 맞게 카멜표기업으로 표시 : api_clr
 * @ nodes : 화면의 Page.Navigation 에서 사용하는 기본 결로 Array
 */
export const BASE = {
    path: `${ptlEnvs.base}/ptl/cstm-role`,
    api: `${process.env.REACT_APP_API_PTLI}/api/v1/ptli/intptl/ptl/cstm-role/mgmt`,
    nodes: [],
};

/*
 * @ APIS
 * @ 화면에서 사용하는 api 정의
 */
export const APIS = {
    getCstmData: (data: any) =>
        api.get(`${BASE.api}/cstm`, { params: comnUtils.toGetParams({ cstmSctnCd: data.cstmSctnCd }) }),
    getSrchRoleList: (data: any, page: number, size: number) =>
        api.get(`${BASE.api}/${data.cstmOrgzId}/srch-role?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams({ roleId: data.roleId, roleNm: data.roleNm }),
        }),
    getCstmRoleList: (data: any) => api.get(`${BASE.api}/${data.cstmOrgzId}/role`),
    getSctnList: () => api.get(`${BASE.api}/sctnList`),
    saveCstmRole: (data: any) =>
        api.post(`${BASE.api}`, { cstmOrgzId: data.cstmOrgzId, cstmRoleList: data.cstmRoleList }),
};

export const SF_CSTMSROLE_SRCH: TFormSchema = {
    id: "form_cstmRoleSrch",
    schema: {
        cstmOrgzId: { type: "text" },
        roleId: { type: "text", label: "L_ROLE_ID" },
        roleNm: { type: "text", label: "L_ROLE_NM" },
        cstmSctnCd: { type: "code", label: "L_CSTM_SCTN_CD", required: true, area: "cstmOrgzCd" },
        cstmOrgzPath: { type: "text", label: "L_CSTM_ORGZ_PATH", edit: false, labelSize: 4 },
    },
};

export const SG_CSTM_ROLE_LIST: TGridSchema = {
    id: "grid_cstmRoleList",
    options: { index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }], show: false },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ header: "L_ROLE_DESC", binding: "roleDesc", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "roleDesc", align: "left" }] },
    ],
};
export const SG_SCRH_ROLE_LIST: TGridSchema = {
    id: "grid_srchRoleList",
    options: { index: true, checkbox: true, pagination: "out", height: 200 },
    head: [
        { cells: [{ header: "L_ROLE_ID", binding: "roleId", width: "*" }] },
        { cells: [{ header: "L_ROLE_NM", binding: "roleNm", width: "*" }] },
        { cells: [{ binding: "isRgsrYn", width: "*" }], show: false },
    ],
    body: [
        { cells: [{ binding: "roleId", align: "center" }] },
        { cells: [{ binding: "roleNm", align: "left" }] },
        { cells: [{ binding: "isRgsrYn", align: "center" }] },
    ],
};
